// jQuery の既定 (400ms, swing) に揃えていて、swing は easeInOutSine と同じ曲線
const OPTIONS = { duration: 400, easing: 'cubic-bezier(0.37, 0, 0.63, 1)' };

// slideToggle が、動いている途中でも向かっている先の状態から反対へ切り替えるために向きも持つ
const slides = new WeakMap();

export function slideDown(element) {
  slide(element, true);
}

export function slideUp(element) {
  slide(element, false);
}

export function slideToggle(element) {
  const opening =
    slides.get(element)?.opening ??
    getComputedStyle(element).display !== 'none';
  slide(element, !opening);
}

// jQuery の .stop() と同じく、動いている途中なら今の高さから向きを変える
function slide(element, opening) {
  const from = currentHeight(element);
  slides.get(element)?.animation.cancel();

  element.style.display = 'block';
  const to = opening ? getComputedStyle(element).height : '0px';

  const animation = element.animate(
    [
      { height: from, overflow: 'hidden' },
      { height: to, overflow: 'hidden' },
    ],
    OPTIONS,
  );
  slides.set(element, { animation, opening });
  animation.onfinish = () => {
    slides.delete(element);
    if (!opening) element.style.display = 'none';
  };
}

function currentHeight(element) {
  const style = getComputedStyle(element);
  return style.display === 'none' ? '0px' : style.height;
}
